import React from "react";

const FeedTitle = () => {
  return (
    <div className="feed">
      <h1>Feed</h1>
      <div className="feed-text">
        <h2>Latest</h2>
        <span>Popular</span>
      </div>
    </div>
  );
};

export default FeedTitle;
